// src/redux-saga/actions/projectActionTypes.js

export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE';

export const ASSIGN_USERS_TO_PROJECT_REQUEST = 'ASSIGN_USERS_TO_PROJECT_REQUEST';
export const ASSIGN_USERS_TO_PROJECT_SUCCESS = 'ASSIGN_USERS_TO_PROJECT_SUCCESS';
export const ASSIGN_USERS_TO_PROJECT_FAILURE = 'ASSIGN_USERS_TO_PROJECT_FAILURE';

export const FETCH_PROJECT_TEAMS_REQUEST = 'FETCH_PROJECT_TEAMS_REQUEST';
export const FETCH_PROJECT_TEAMS_SUCCESS = 'FETCH_PROJECT_TEAMS_SUCCESS';
export const FETCH_PROJECT_TEAMS_FAILURE = 'FETCH_PROJECT_TEAMS_FAILURE';

export const REMOVE_PROJECT_TEAMS_REQUEST = 'REMOVE_PROJECT_TEAMS_REQUEST';
export const REMOVE_PROJECT_TEAMS_SUCCESS = 'REMOVE_PROJECT_TEAMS_SUCCESS'; 
export const REMOVE_PROJECT_TEAMS_FAILURE = 'REMOVE_PROJECT_TEAMS_FAILURE';



export const fetchProjectsRequest = ({ page = 1, limit = 1, search = '' } = {}) => ({
  type: FETCH_PROJECTS_REQUEST,
  payload: { page, limit, search },
});


  
  export const fetchProjectsSuccess = (data) => ({
    type: FETCH_PROJECTS_SUCCESS,
    payload: data,
  });
  
  export const fetchProjectsFailure = (error) => ({
    type: FETCH_PROJECTS_FAILURE,
    payload: error,
  });
  
  // Action Creators for Creating Projects
  export const createProjectRequest = (projectData) => ({
    type: CREATE_PROJECT_REQUEST,
    payload: projectData,
  });
  
  export const createProjectSuccess = (data) => ({
    type: CREATE_PROJECT_SUCCESS,
    payload: data,
  });
  
  export const createProjectFailure = (error) => ({
    type: CREATE_PROJECT_FAILURE,
    payload: error,
  });
  
  // Action Creators for Updating Projects
  export const updateProjectRequest = (projectId, projectData) => ({
    type: UPDATE_PROJECT_REQUEST,
    payload: { projectId, projectData },
  });
  
  export const updateProjectSuccess = (data) => ({
    type: UPDATE_PROJECT_SUCCESS,
    payload: data,
  });
  
  export const updateProjectFailure = (error) => ({
    type: UPDATE_PROJECT_FAILURE,
    payload: error,
  });
  
  // Action Creators for Deleting Projects
  export const deleteProjectRequest = (projectId) => ({
    type: DELETE_PROJECT_REQUEST,
    payload: projectId,
  });
  
  export const deleteProjectSuccess = (projectId) => ({
    type: DELETE_PROJECT_SUCCESS,
    payload: projectId,
  });
  
  export const deleteProjectFailure = (error) => ({
    type: DELETE_PROJECT_FAILURE,
    payload: error,
  });
  
  // Action Creator for Assigning Users to Project
  export const assignUsersToProjectRequest = (projectId, teamIds) => ({
    type: ASSIGN_USERS_TO_PROJECT_REQUEST,
    payload: { projectId, teamIds },
  });
  
  export const assignUsersToProjectSuccess = (data) => ({
    type: ASSIGN_USERS_TO_PROJECT_SUCCESS,
    payload: data,
  });
  
  export const assignUsersToProjectFailure = (error) => ({
    type: ASSIGN_USERS_TO_PROJECT_FAILURE,
    payload: error,
  });


  export const fetchProjectTeamsRequest = (projectId) => ({
    type: FETCH_PROJECT_TEAMS_REQUEST,
    payload: projectId,
  });
  
export const fetchProjectTeamsSuccess = (data) => ({
    type: FETCH_PROJECT_TEAMS_SUCCESS,
    payload: data,
  });
  
export const fetchProjectTeamsFailure = (error) => ({
    type: FETCH_PROJECT_TEAMS_FAILURE,
    payload: error,
  });

export const removeProjectTeamsRequest = (projectId, teamIds) => ({
    type: REMOVE_PROJECT_TEAMS_REQUEST,
    payload: { projectId, teamIds },
  });
  
export const removeProjectTeamsSuccess = (data) => ({
    type: REMOVE_PROJECT_TEAMS_SUCCESS, 
    payload: data,
  });
  
export const removeProjectTeamsFailure = (error) => ({
    type: REMOVE_PROJECT_TEAMS_FAILURE,
    payload: error,
  });
